<template>
    <form @submit.prevent="save" class="modal">
        <div class="head">Добавление домофона</div>

        <div class="input_row">
            <div class="input">
                <div class="desc">Название домофона</div>
                <input v-model="name" type="text">
            </div>
            <div class="input">
                <div class="desc">Номер подъезда</div>
                <input v-model="entranceNumber" type="text">
            </div>
            <div class="input">
                <div class="desc">IP-адрес домофона</div>
                <input v-model="ip" type="text">
            </div>
        </div>

        <div class="input_row">
            <div class="input">
                <div class="desc">Порт домофона</div>
                <input v-model="port" type="text">
            </div>
            <div class="input">
                <div class="desc">Пароль для домофона</div>
                <input v-model="password" type="text">
            </div>
            <div class="input">
                <div class="desc">Имя пользователя домофона</div>
                <input v-model="username" type="text">
            </div>
        </div>

        <div class="input_row">
            <div class="input">
                <div class="desc">IP для видео</div>
                <input v-model="videoIP" type="text">
            </div>
            <div class="input">
                <div class="desc">Порт для видео</div>
                <input v-model="videoPort" type="text">
            </div>
            <div class="input">
                <div class="desc">Имя пользователя для видео</div>
                <input v-model="videoUsername" type="text">
            </div>
        </div>

        <div class="input_row">
            <div class="input">
                <div class="input">
                    <div class="desc">Пароль для видео</div>
                    <input v-model="videoPassword" type="text">
                </div>
            </div>
        </div>

        <div class="buttons">
            <button>Сохранить</button>
            <div @click="$store.commit('changeShowModal', 'AddIntercom')" class="cancel">
                <img src="@/assets/img/left_arrow.svg" alt="">
                <div class="text">Назад</div>
            </div>
        </div>

        <div @click="$store.commit('changeShowModal', 'AddIntercom')" class="close">
            <img src="@/assets/img/close.svg" alt="">
        </div>
    </form>
</template>


<script>
export default {
    data() {
        return {
            name: "",
            entranceNumber: "",
            ip: "",
            port: "",
            username: "",
            password: "",
            videoIP: "",
            videoPort: "",
            videoUsername: "",
            videoPassword: ""
        }
    },
    methods: {
        async save() {
            let r = await this.$store.dispatch("request", {
                method: "POST",
                path: "/adm/panels",
                sendData: {
                    type: 2,
                    building_id: this.$store.getters.activeHouseID,
                    description: this.name,
                    entrance: this.entranceNumber,
                    ip: this.ip,
                    port: this.port,
                    username: this.username,
                    password: this.password,
                    video_host: this.videoIP,
                    video_port: this.videoPort,
                    video_username: this.videoUsername,
                    video_password: this.videoPassword
                }
            })
            if (r.status == 200) {
                this.$store.commit("changeShowModal", "AddIntercom")
                this.$store.dispatch("loadData")
            }
        }
    }
}
</script>


<style lang="scss" scoped>
.modal {
    .input_row {
        display: flex;
        margin-bottom: 26px;
        .input {
            margin-left: 16px;
            .desc {
                margin-bottom: 16px;
            }
            input {
                width: 320px;
            }
        }
        .input:first-child {
            margin-left: 0;
        }
    }
}
</style>